// extracted by mini-css-extract-plugin
export default {"pricing-cards":"style_pricing-cards__HvDrQ","pricing-card-standalone":"style_pricing-card-standalone__Phr4y"};